import axios from '../../helpers/axios-setup';
import { AxiosResponse } from 'axios';
import { LabRequest } from '../../components/pages/atl-testing/types';

export const getLabRequest = (id: number) => axios.get<LabRequest, AxiosResponse<LabRequest>>(`/lab-requests/${id}`);
